import styled from 'styled-components'

type Size = 'mobile' | 'tablet' | 'desktop'

interface HasLimit {
  limit: string
}

// if 740, then show mobile, hide tablet
// if bigger than 741, show tablet, hide mobile
export const HideBiggerThan = styled.div<HasLimit>`
  @media (min-width: ${props => props.limit}) {
    display: none;
  }
`

// desktop view: https://stackoverflow.com/a/72698167/968988
export const HideSmallerThan = styled.div<HasLimit>`
  display: none;
  @media (min-width: ${props => props.limit}) {
    display: block;
  }
  @media (max-width: ${props => props.limit}) {
    display: none;
  }
`
